import { render, staticRenderFns } from "./InformacoesJovemAprendiz2026.vue?vue&type=template&id=98093d2c&"
import script from "./InformacoesJovemAprendiz2026.vue?vue&type=script&lang=js&"
export * from "./InformacoesJovemAprendiz2026.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports